module.exports = __webpack_public_path__ + "img/china.85315e48.png";